export const getStyled = () => ({
  multFieldLine: {
    display: 'flex',
    marginTop: 8,
  },
  uploadInput: {
    display: 'none',
  },

  btns: {
    margin: 15,
  },
});
